import { ALL_FOOTERS_IN_ORDER } from './constants';

export const getMaxFooterPage = (
  enrollmentStatus: string,
  requiredTask: string,
  activeHeader: number,
  maxHeaderItem: number,
  allPages: (string | undefined)[]
) => {
  if (enrollmentStatus === 'null' || enrollmentStatus === 'undefined') {
    return undefined;
  }

  // the user must have completed prev steps, all footer components enabled
  if (maxHeaderItem > activeHeader) {
    return allPages.length - 1;
  }

  const maxIndex = allPages.findIndex((page) => page === enrollmentStatus);
  if (enrollmentStatus === 'decision_support' && activeHeader === 0) {
    // as we add the other decision support pages, we may need to update this
    return allPages.length - 1;
  } else if (maxIndex < 0) {
    return undefined;
  }
  return maxIndex;
};

export const isNewStatus = (
  onPage: string | undefined,
  enrollmentStatus: string
) => {
  if (enrollmentStatus === '') {
    return true;
  }
  return (
    ALL_FOOTERS_IN_ORDER.indexOf(String(onPage)) >
    ALL_FOOTERS_IN_ORDER.indexOf(enrollmentStatus)
  );
};
